import React, { useState } from 'react'

import { ModalBasicProps } from '@probatix/myprobatix/core/shell/components/ModalRoot/ModalRoot'
import { CustomModal } from '@probatix/common/components/molecules'

type BasicModalViewProps = ModalBasicProps & {
  defaultValues: any
  loading: boolean,
  onHideModal: any,
}

const BasicModalView: React.FC<BasicModalViewProps> = ({
  defaultValues,
  onHideModal,
}) => {
  const [open, setOpen] = useState(true)

  const closeModal = () => {
    setOpen(false)
    onHideModal()
  }

  return (
    <CustomModal
      $isActiveModal={open}
      hideCrossButton={false}
      isOpen={open}
      scrollTop={defaultValues.scrollTop}
      title={defaultValues.title}
      showTitleOnDialog
      onClose={closeModal}
    >
      {defaultValues.element}
    </CustomModal>
  )
}

export default BasicModalView
